import { Breadcrumbs, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { CongregationForm } from "components/congregation-form";
import { Link, useLocation } from "react-router-dom";
import ROUTE_NAMES from "routes/routeNames";
import { useDispatch } from "react-redux";
import { getAllStates } from "modules/congregation/action";

const RequestCongregationDetails = (params: any) => {
  const location = useLocation();
  const dispatch: Function = useDispatch();

  let congregationId = location?.state?.id;

  console.log("congregationId", congregationId);
  React.useEffect(() => {
    dispatch(getAllStates({}));
  }, []);
  return (
    <Box>
      <Typography gutterBottom variant="h1" fontWeight={700}>
        Congregation
      </Typography>
      <Breadcrumbs>
        <Link to={ROUTE_NAMES.MAIN_ROUTES.CONGREGATIONS}>Congregation</Link>
        <Link to={ROUTE_NAMES.MAIN_ROUTES.REQUESTED_CONGREGATION}>
          Request Congregation
        </Link>
        <Link to="#">Congregation Details</Link>
      </Breadcrumbs>
      <Box my={1}>
        <CongregationForm isRequested={true} />
      </Box>
    </Box>
  );
};
export default RequestCongregationDetails;
